var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNoDataWithFilters)?_c('gl-empty-state',{attrs:{"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description,"svg-path":_vm.filtersEmptyStateSvgPath,"svg-height":150}}):_c('empty-state-without-any-issues',{attrs:{"show-new-issue-dropdown":_vm.showNewIssueDropdown}})
}
var staticRenderFns = []

export { render, staticRenderFns }